module.exports = __webpack_public_path__ + "img/01_full.a7da65f1.jpg";